//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { IConfiguration } from '@apis/tagged-by-curalate-automation/automationApiModels';
import { AUTO_DISTRIBUTION_HELPER_TEXT } from '@collections/constants/partnerStreamConstants';
import { BodySecondaryText } from '@components/atoms/text/Text';
import { actions as streamDrawerActions } from '@streams/actions/streamDrawerActions';

const AutoActiveConfigRules = () => {
  const dispatch = useDispatch();

  const taggedByBvAutomationActiveConfiguration = useSelector(
    (state: {
      streams: {
        streamsDrawer: {
          taggedByBvAutomationActiveConfiguration: IConfiguration | undefined;
        };
      };
    }) => state.streams.streamsDrawer.taggedByBvAutomationActiveConfiguration,
  );

  const hasConfiguration =
    taggedByBvAutomationActiveConfiguration !== undefined &&
    Object.keys(taggedByBvAutomationActiveConfiguration).length > 0;

  useEffect(() => {
    if (!hasConfiguration) {
      void dispatch(streamDrawerActions.fetchTaggedByBVAutomationConfigs());
    }
  }, [dispatch, hasConfiguration]);

  return (
    <TextWrapper>
      {hasConfiguration && (
        <TextContent>{AUTO_DISTRIBUTION_HELPER_TEXT}</TextContent>
      )}
    </TextWrapper>
  );
};

const TextWrapper = styled.div(
  ({ theme }) => `
  margin: ${theme.spacings[2]} ${theme.spacings[3]};
`,
);

const TextContent = styled(BodySecondaryText)`
  padding: ${({ theme }) => theme.spacings[1]};
`;

export { AutoActiveConfigRules };
